// reference
import {
  HeatDetectionModis48,
  HeatDetectionModis7,
  HeatDetectionViirs48,
  HeatDetectionViirs7
} from '@/constants/layers/hotspots/LivingAtlasHeatDetection'
import { BurnedAreasViirs1Day, BurnedAreasViirs7Days, BurnedAreasViirs30Days } from '@/constants/layers/hotspots/Viirs'
import IncidentsLayer from '@/constants/layers/incidentsLayer.ts'
// import GeographicAreas from "@/constants/layers/referenceLayers/conus/geographicAreas.ts"
// import DispatchCenters from "@/constants/layers/referenceLayers/conus/dispatchCenters.ts"
// import Counties from "@/constants/layers/referenceLayers/conus/counties.ts"
// import PredictiveServiceAreas from "@/constants/layers/referenceLayers/conus/predictiveServiceAreas.ts"
// import SevereFireDangerIndex from "@/constants/layers/referenceLayers/conus/severeFireDangerIndex.ts"
// import States from "@/constants/layers/referenceLayers/conus/states.ts"
// import EnergyReleaseComponentPercentileForecast from "@/constants/layers/referenceLayers/conus/energyReleaseComponentPercentileForecast.ts"
// import BiPercentileForecast from "@/constants/layers/referenceLayers/conus/BiPercentileForecast.ts"
// import DroughtMonitor from "@/constants/layers/referenceLayers/conus/droughtMonitor.ts"
// import MicrosoftBuildings from "@/constants/layers/referenceLayers/conus/microsoftBuildings.ts"
// import NifsPublicPerimeter from "@/constants/layers/referenceLayers/conus/NifsPublicPerimeters.ts"

// boundaries
// import AdminDivisions0 from "@/constants/layers/boundaries/AdminDivisions0.ts"
// import AdminDivisions1 from "@/constants/layers/boundaries/AdminDivisions1.ts"
// import AdminDivisions2 from "@/constants/layers/boundaries/AdminDivisions2.ts"

// fire
// import Firms from "@/constants/layers/referenceLayers/Firms"

// VIIRS & modis & SUOMI
import type { OrganizationLayers } from '@/types/OrganizationLayers'

export const non_authenticated: OrganizationLayers = {
  id: 'default',
  toc: [
    {
      name: 'reference',
      layers: [IncidentsLayer]
    },
    // { name: "boundaries", layers: [AdminDivisions0, AdminDivisions1, AdminDivisions2] },
    { name: 'burnedAreas:viirs', layers: [BurnedAreasViirs1Day, BurnedAreasViirs7Days, BurnedAreasViirs30Days] },
    { name: 'heatDetection:modis', layers: [HeatDetectionModis48, HeatDetectionModis7] },
    { name: 'heatDetection:viirs', layers: [HeatDetectionViirs48, HeatDetectionViirs7] }
  ]
}

export const common_authenticated: OrganizationLayers = {
  id: 'default',
  toc: [
    ...non_authenticated.toc.map((group) => ({ ...group, layers: [...group.layers] }))
    // Add more authenticated-only layers here if needed
  ]
}

// Add individual layers
// common_authenticated.toc.find((c) => c.name === "reference").layers.push(bookMarksLayer)
